<template>
  <!-- 模板 -->
  <div class="index">
    <div class="container container1">
      <div class="top clearfix">
        <div class="top-left col-xs-12 col-sm-6">
          <img src="@/assets/image/pan.png" alt="">
          <span>比賽花絮</span>
        </div>

        <div class="top-right col-xs-12 col-sm-6">
          <ul>
            <li>
              <a class="is-check">比賽花絮</a>
            </li>
            <li>
              <router-link to="all-titbits">歷届花絮</router-link>
            </li>
          </ul>
        </div>
      </div>
      <!-- <hr> -->

      <div class="content col-xs-12 clearfix none-padding">
        <div class="col-xs-12 none-padding ">
          <!--<div class="video-left col-xs-12 col-sm-8">-->
            <!--<template v-if="videoUrl">-->
              <!--<iframe :src="videoUrl" frameborder="0" allow="autoplay; encrypted-media" allowfullscreen></iframe>-->
            <!--</template>-->
            <!--&lt;!&ndash;<video src="@/assets/aaaa.mp4" poster=""></video>&ndash;&gt;-->
          <!--</div>-->
          <!--<div class="video-right col-xs-12 col-sm-4">-->
            <!--&lt;!&ndash; clearfix &ndash;&gt;-->
            <!--<ul class="" :style="{'width': isMobile ? ulWidth : ''}">-->
              <!--<li class="" v-for="(video) in videoList" :key="video.id" @click="changeUrl(video.youtube_id)">-->
                <!--<img class="col-sm-4 none-padding" :src="'http://img.youtube.com/vi/' + video.youtube_id + '/default.jpg'" alt="">-->
                <!--<div class="hidden-xs col-sm-8">-->
                  <!--<h5>{{video.file_names}}</h5>-->
                  <!--<span>日期：{{video.create_time|moment("YYYY.MM.DD")}}</span>-->
                <!--</div>-->
              <!--</li>-->
              <!--&lt;!&ndash;<li class="">&ndash;&gt;-->
                <!--&lt;!&ndash;<img class="col-sm-4" src="@/assets/image/thumbil.png" alt="">&ndash;&gt;-->
                <!--&lt;!&ndash;<div class="hidden-xs col-sm-8">&ndash;&gt;-->
                  <!--&lt;!&ndash;<h5>第26屆滙業盃總決賽精華片段</h5>&ndash;&gt;-->
                  <!--&lt;!&ndash;<span>日期：2018.12.10</span>&ndash;&gt;-->
                <!--&lt;!&ndash;</div>&ndash;&gt;-->
              <!--&lt;!&ndash;</li>&ndash;&gt;-->
            <!--</ul>-->

          <!--</div>-->
          <img src="./banner.png" class="top-banner" alt="">
        </div>    <!-- video list end -->

        <div class=" col-xs-12 photo-list" v-if="videoList.length > 0">
          <span class="news-title">歷届影片</span>
          <div class="transverse-line"></div>
          <div class="col-xs-12 photo">
            <div v-for="(video, index) in videoList" :key="video.id" class="col-xs-6 col-sm-3 the-video-bg" @click="showVideo(video.youtube_id,index)">
            <img :src="'http://img.youtube.com/vi/' + video.youtube_id + '/default.jpg'" alt="">
            <div class="this-video-btn"><img src="@/assets/image/video_btn.png"></div>
            <div class="p-title">{{video.file_names}}</div>
            </div>
          </div>
        </div>

        <div class=" col-xs-12 photo-list" v-if="photoList.length > 0">
          <span class="news-title">歷届相片</span>
          <div class="transverse-line"></div>
          <div class="col-xs-12 photo">
            <!--<div class="col-xs-6 col-sm-3 photo-bg" @click="showAlert(2)">-->
              <!--<img src="@/assets/image/second_bg.png" alt="">-->
              <!--<div class="p-title">第26屆滙業盃總決賽精華片段</div>-->
            <!--</div>-->
            <div v-for="(photo, index) in photoList" :key="photo.id" @click="showAlert(index)" class="col-xs-6 col-sm-3 photo-bg">
              <img :src="photo.album[0].photo_urls" alt="">
              <div class="p-title">{{photo.type_name}}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container none-padding">
      <div class="tibits col-xs-10 col-sm-12 col-xs-offset-1 col-sm-offset-0" v-if="numberList.length > 0">
        <span class="news-title">歷届花絮</span>
        <div class="transverse-line"></div>
        <div class=" tibits-list ">
          <div class="t-list-one " v-for="(number) in numberList" :key="number.id" @click="goToTitbits(number.id, number.cate_id)" >
              <img :src="number.thumbnail_url" alt="">
              <span>{{number.title}}</span>
          </div>
        </div>
      </div>
    </div>
    <!--相册轮播图-->
    <album ref="photoAlert"></album>
    <!--视频播放页面-->
    <album-video ref="videoAlert"></album-video>
  </div>

</template>
<script>
import album from '../titbits/albumPhoto'
import albumVideo from '../titbits/albumVideo'
export default {
  data () {
    return {
      'numberList': [],    // 届数列表
      'videoList': [],     // 视频列表
      'photoList': [],      // 相册列表
      'videoUrl': '',      // 视频链接
      'ulWidth': '375px',
      'isMobile': false
    }
  },
  components: {
    'album': album,
    'album-video': albumVideo
  },
  methods: {
    goToTitbits: function (id, cateId) {
      this.$router.push({name: 'all-titbits', params:{id: id, cate_id: cateId}})
    },
    allList: function () {
      var that = this
      this.$axios.get('/award/list')
        .then(function (respone) {
          that.numberList = respone.data.data

          // console.log(respone.data.data)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    newestFeautre: function (cateId) {
      var that = this
      this.$axios.get('/award/titbits')
        .then(function (respone) {
          that.videoList = respone.data.data.video
          that.photoList = respone.data.data.photo
          that.videoUrl = 'https://www.youtube.com/embed/' + that.videoList[0].youtube_id
          that.ulWidth = that.videoList.length * 90 + 'px'
          // console.log(that.videoList)
          // console.log(that.ulWidth)
          // console.log(that.photoList)
        })
        .catch(function (error) {
          console.log(error)
        })
    },
    // 傳入相冊數組的下標
    showAlert: function (key) {
      if (document.body.clientWidth >= 768) {
        this.$refs.photoAlert.show(this.photoList[key])
      } else {
        this.$router.push({name: 'mobile-album', query: {type_id: this.photoList[key].id}})
      }
    },
    // 改变videoUrl
    changeUrl: function (youtubeId) {
      this.videoUrl = 'https://www.youtube.com/embed/' + youtubeId
    },
    showVideo: function (youtubeId, index) {
      this.$refs.videoAlert.show(index,youtubeId, this.videoList)
    }
  },
  created: function () {
    if (document.body.clientWidth < 768) {
      this.isMobile = true
    }
    this.goTop()
    this.newestFeautre()
    this.allList()
  }
}
</script>
<style scoped>
  .index {

  }

  .container1 {
    background: #FFFFFF;
    box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.50);
    border-radius: 5px;
    margin-top: 80px;
    min-height: 900px;
    padding: 0px;

  }

  .container hr {
    margin-top: 0px;
    height: 5px;
    /*border: ;*/
    background: #617BE4;
  }

  .top {
    font-family: PingFangSC-Medium;
    color: #565656;
    border-bottom: 5px solid #617BE4;
    padding-bottom: 5px;
    /*margin-bottom: 10px;*/
  }

  .top .top-left {
    display: inline-block;
    margin-top: 5px;
    padding-bottom: 8px;
    padding-top: 8px;
  }

  .top .top-left img {
    margin-bottom: 5px;
  }

  .top .top-left span {
    font-size: 24px;
  }

  .top .top-right {
    text-align: right;
    margin-top: 10px;
    padding-top: 5px;
  }

  .top ul li {
    display: inline-block;
    margin-right: 20px;
    font-size: 20px;

  }

  .top ul li a {
    border: 2px solid rgba(0,0,0,0);
    padding: 2px 15px;
    color: #565656;
  }

  .top ul li a:hover, .top ul li a:focus {
    border: 2px solid #5571EC;
    border-radius: 60px;
    color: #5571EC;
    text-decoration: none;
  }

  .top .is-check{
    border: 2px solid #5571EC;
    border-radius: 60px;
    color: #5571EC;
    text-decoration: none;
  }

  .photo-list {
    margin-top: 30px;
    margin-bottom: 40px;

  }
  .photo-list .photo{
    padding: 0px;
  }

  .the-video-bg{
    cursor: pointer;
    padding: 0px;
    margin-right: 20px;
    margin-top: 20px;
    width: 220px;
    text-align: center;
    border:1px solid rgba(192,194,197,1);
    border-radius: 0 0 11px 11px;
  }
  .the-video-bg:hover .p-title{
    color: #526add;
  }
  .the-video-bg img{
    /*margin-top: 10px;*/
    margin-right: 0px;
    width: 100%;
    height: 130px;
  }
  .this-video-btn {
    position: absolute;
    top: 30%;
    left: 37%;
  }
  .this-video-btn img{
    height: 100%;
  }
  .the-video-bg .p-title{
    font-size: 14px;
    color: #565656;
    margin:10px auto;
  }

  .tibits {
    margin-top: 20px;
    /*margin-left: 100px;*/
  }

  .tibits .tibits-list .t-list-one {
    width: 295px;
    height: 90px;
    margin-left: 20px;
    margin-bottom: 20px;
    border: 1px solid #C0C2C5;
    border-radius: 10px;
    display: inline-block;
    cursor: pointer;
  }

  .tibits .tibits-list .t-list-one:hover span{
    color: #526add;
  }

  .tibits .tibits-list .t-list-one img {
    width: 100px;
    height: 88px;
    display: inline-block;
    border-radius: 10px;
  }

  .tibits .tibits-list .t-list-one span {
    width: 190px;
    margin-top: 20px;
    display: inline;
    vertical-align: middle;
    float: right;
    color: #000;
  }

  @media (min-width: 992px) {
    .photo-list .photo {
      margin-left: 5%;
    }
  }

  @media (max-width: 1050px) {
    .tibits {
      /*margin-left: 10px;*/
    }
  }
  @media (max-width: 992px) and (min-width: 768px){
    .photo-list{
      padding: 0px;
    }
  }
  @media (max-width: 767px) {
    .top .top-right {
      text-align: center;
    }

    .top ul li {
      font-size: 16px;
    }

    .the-video-bg{
      /*margin-top: 20px;*/
      padding: 0px;
      margin-right: 7px;
      margin-top: 20px;
      width: 150px;
      height: 140px;
    }
    .the-video-bg img{
      margin-right: 0px;
      width: 100%;
      height: 80px;
    }
    .this-video-btn {
      top: 22%;
      left: 38%;
    }
    .this-video-btn img{
      height: 100%;
    }
    .the-video-bg .p-title{
      font-size: 10px;
      color: #565656;
      margin:10px auto;
    }
    .photo-list .photo{
      padding: 0px;
    }

    .tibits .tibits-list .t-list-one{
      margin-left: 0px;
    }

    .photo{
      width: 98%;
      margin-left: 1%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/titbits/index.vue